import script from "./CanvasCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanvasCard.vue?vue&type=script&setup=true&lang=ts"

import "./CanvasCard.vue?vue&type=style&index=0&id=115d69cd&scoped=true&lang=stylus"
script.__scopeId = "data-v-115d69cd"

export default script